export default "__VITE_ASSET__CDY86MBx__"